export const DEFAULT_OVERLAY_COLOR = "rgba(0, 0, 0, 0.5)";

export function modifyOverlayColor(color: string): string {
  return color.length < 9 ? color + "ee" : color;
}
